export const CHAT_MODES = Object.freeze(['lite', 'standard', 'ultra'])

export const DEFAULT_CHAT_MODE = 'standard'

export function isChatMode(value) {
  return CHAT_MODES.includes(value)
}

export function normalizeChatMode(value) {
  return isChatMode(value) ? value : DEFAULT_CHAT_MODE
}
